import { sizes } from '../sizing.js';
export const iconSizes = {
    small: sizes.x3,
    standard: sizes.x4,
    large: sizes.x6,
    illustrative: sizes.x16,
};
export const beameryIconSize = {
    width: '118px',
    height: '32px',
};
export const strokeWidths = {
    default: '1.5',
    illustrative: '4px',
};
//# sourceMappingURL=icons.js.map